module.exports = __webpack_public_path__ + "img/icon12.53520697.png";